import { useContext, useMemo } from "react";
import { routesMaster } from "../main/routes-role";
import { MeContext } from "../contexts/me-context/me-context";
import { useTranslation } from "react-i18next";

export const useRouteRole = () => {
    const { t } = useTranslation("sidebar");
    const { me } = useContext(MeContext);
    const permissions = me?.permissions ?? [];
    // Pré-RBAC (backend ainda não envia permissions): admin legado vê o menu
    // inteiro. Ver nota em use-permission.ts.
    const isLegacyAdmin = me?.permissions == null && me?.role === "admin";

    const routes = useMemo(() => {
        return routesMaster(t, permissions, isLegacyAdmin);
    }, [t, permissions.join(","), isLegacyAdmin]);

    return { routes };
};
